/* Livena premium product-page behaviour.
   1) Finger-linked luxe gallery transition.  2) Subtle delivery line.
   3) Reveal-on-scroll.  4) Repeated CTA -> scroll to buy box.
   5) Bundle/quantity selector -> sets the cart quantity. */
(function () {
  'use strict';

  var mqMobile = window.matchMedia('(max-width: 749px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var attached = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  function smoothstep(x) { x = x < 0 ? 0 : (x > 1 ? 1 : x); return x * x * (3 - 2 * x); }

  function attachGallery(gallery) {
    var scroller = gallery.querySelector('slideshow-slides');
    if (!scroller) return;
    var ticking = false;
    function update() {
      ticking = false;
      var sr = scroller.getBoundingClientRect();
      var mid = sr.left + sr.width / 2;
      var slides = scroller.querySelectorAll('slideshow-slide');
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        if (!r.width) continue;
        var c = r.left + r.width / 2;
        var signed = (c - mid) / r.width;
        var p = smoothstep(1 - Math.abs(signed));
        var shift = (signed < 0 ? -1 : 1) * (1 - p) * 9;
        slides[i].style.setProperty('--lux-p', p.toFixed(4));
        slides[i].style.setProperty('--lux-shift', shift.toFixed(2) + 'px');
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    scroller.addEventListener('scroll', onScroll, { passive: true });
    if ('ResizeObserver' in window) { new ResizeObserver(onScroll).observe(scroller); }
    if ('MutationObserver' in window) { new MutationObserver(onScroll).observe(scroller, { childList: true }); }
    gallery.__lvUpdate = update;
    requestAnimationFrame(update);
  }

  function refreshGalleries() {
    var on = mqMobile.matches && !mqReduce.matches;
    var gs = document.querySelectorAll('media-gallery.media-gallery--hint');
    for (var i = 0; i < gs.length; i++) {
      var g = gs[i];
      if (on) {
        if (!attached || !attached.has(g)) { if (attached) attached.add(g); attachGallery(g); }
        g.setAttribute('data-lux-init', '');
        if (g.__lvUpdate) g.__lvUpdate();
      } else { g.removeAttribute('data-lux-init'); }
    }
  }

  function setupReveal() {
    if (mqReduce.matches || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.ts-iwt__inner, .ts-rev__inner, .ts-cols__inner, .ts-faq__inner, .lv-sec__inner');
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lv-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var vh = window.innerHeight || 800;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].getBoundingClientRect().top > vh * 0.85) { targets[i].classList.add('lv-reveal'); io.observe(targets[i]); }
    }
  }

  function setupCtaScroll() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.lv-cta-scroll') : null;
      if (!t) return;
      e.preventDefault();
      var dest = document.querySelector('.product-information');
      if (!dest) return;
      var top = dest.getBoundingClientRect().top + window.pageYOffset - 14;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    });
  }

  /* ---------- 5) Bundle / quantity selector ---------- */
  function setQuantity(q) {
    var input = document.querySelector('.product-information quantity-selector-component input[name="quantity"]') ||
                document.querySelector('.product-information input[name="quantity"]');
    if (!input) return;
    input.value = q;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
  }
  function setupBundle() {
    var groups = document.querySelectorAll('.lv-bundle__opts');
    if (!groups.length) return;
    document.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('.lv-bundle__opt') : null;
      if (!opt) return;
      e.preventDefault();
      var group = opt.parentNode;
      var all = group.querySelectorAll('.lv-bundle__opt');
      for (var i = 0; i < all.length; i++) { all[i].classList.remove('is-selected'); all[i].setAttribute('aria-checked', 'false'); }
      opt.classList.add('is-selected'); opt.setAttribute('aria-checked', 'true');
      setQuantity(opt.getAttribute('data-qty') || '1');
    });
    var pre = document.querySelector('.lv-bundle__opt.is-selected');
    if (pre) setQuantity(pre.getAttribute('data-qty') || '1');
  }

  function init() { refreshGalleries(); setupReveal(); setupCtaScroll(); setupBundle(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function () { refreshGalleries(); setupBundle(); });
  window.addEventListener('resize', function () { requestAnimationFrame(refreshGalleries); }, { passive: true });
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', refreshGalleries);
})();
